<template>
  <div class="about" v-show="false">
    <h1>Logout</h1>
  </div>
</template>
<script>
export default {
  name: "Logout",
  mounted() {
    this.logout();
  },
  methods: {
    logout() {
      this.$auth
        .logout({
          url: "/api/logout",
          makeRequest: true,
          redirect: { name: "Login" }
        })
        .then(() => {
          this.$store.commit("SET_ISLOGGED", false);
          this.$store.commit("SET_RUTACTIVA", null);
          this.$store.commit("SET_DETALLERUTA", null);
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
};
</script>
